import axios from '../axios'
import config from "@/utils/global.js";
/* 
 * 用户管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: config.zuul+'/xyj-admin/w/user/save',
        method: 'post',
        data
    })
}
// 修改密码
export const updatePwd = (params) => {
    return axios({
        url: config.zuul+'/xyj-admin/w/partUser/updatePwd',
        method: 'get',
        params
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: config.zuul+'/xyj-admin/w/user/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: config.zuul+'/xyj-admin/r/user/findPage',
        method: 'post',
        data
    })
}
// 查找用户的菜单权限标识集合
export const findPermissions = (params) => {
    return axios({
        url: config.zuul+'/xyj-admin/r/user/findPermissions',
        method: 'get',
        params
    })
}
// 查找用户的菜单权限标识集合
export const findBranchPermissions = (params) => {
    return axios({
        url: config.zuul+'/xyj-admin/r/sysBranchUser/findPermissions',
        method: 'get',
        params
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/user.js